import { render, staticRenderFns } from "./editSocialModel.vue?vue&type=template&id=77d19a38&scoped=true"
import script from "./editSocialModel.vue?vue&type=script&lang=js"
export * from "./editSocialModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d19a38",
  null
  
)

export default component.exports